module.exports = __webpack_public_path__ + "static/media/006-Wechseln (ohne Informieren)_ID_2.19bf4c34.mp3";